module.exports = __webpack_public_path__ + "img/20180815_145537_010.4b5d8584.jpg";